import { CSSObject } from '@chakra-ui/react';

export const BoxWrapper: CSSObject = { bg: 'transparent', h: 'full' };

export const ButtonDropdown: CSSObject = {
  bg: 'alpha.500',
  borderColor: 'alpha.500',
  color: 'white',
  h: 'full',

  _hover: {
    bg: 'alpha.600',
    borderColor: 'alpha.600',
  },
};
export const BoxDropdown: CSSObject = {
  bg: 'alpha.500',
  color: 'white',
  zIndex: 'docked',
  h: 'full',
};
export const TextTitle: CSSObject = {
  color: 'white',
};
